export var sortQuestions = function (arr) {
    return arr.sort(function (n1, n2) {
        return n1.order > n2.order ? 1 : n1.order < n2.order ? -1 : 0;
    });
};
//# sourceMappingURL=game.js.map